import { render, staticRenderFns } from "./CrosswalkModal.vue?vue&type=template&id=35f9abe0&"
import script from "./CrosswalkModal.vue?vue&type=script&lang=js&"
export * from "./CrosswalkModal.vue?vue&type=script&lang=js&"
import style0 from "./CrosswalkModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports